import { Button } from "@/components/ui/button";
import { GameMetadata } from "./common/game-registry";
import { ArrowLeft } from "lucide-react";
import { Leaderboard } from "./common/leaderboard";

export const PlayHeader = ({
  game,
  title,
  onClickBack,
}: {
  game: GameMetadata | null;
  title: string;
  onClickBack: () => void;
}) => {
  const renderRankInfo = () => {
    if (!game || !game.rank) return null;
    return <Leaderboard gameId={game.id} />;
  };

  const renderGameInfo = () => {
    if (!game) return null;
    return (
      <div className="flex items-center gap-2">
        <span className="font-semibold">{game.name}</span>
      </div>
    );
  };

  return (
    <div className="flex justify-between p-3 border-b bg-muted">
      <div className="flex items-center gap-2 ">
        <Button variant="outline" size="default" onClick={() => onClickBack()}>
          <ArrowLeft className="w-4 h-4" />
        </Button>
        <span className="font-semibold">{title}</span>
      </div>
      <div className="flex items-center gap-2">
        {renderGameInfo()}
        {renderRankInfo()}
      </div>
    </div>
  );
};
